import React, { useEffect, useState, useRef } from 'react';

interface AnimatedSplashProps {
  onComplete: () => void;
}

/**
 * Full-screen splash component that displays a static logo image.
 * Shows for 2 seconds before fading out to the main app.
 */
const AnimatedSplash: React.FC<AnimatedSplashProps> = ({ onComplete }) => {
  const [isFadingOut, setIsFadingOut] = useState(false);
  const hasCompletedRef = useRef(false);

  const handleComplete = () => {
    if (hasCompletedRef.current) return;
    hasCompletedRef.current = true;
    
    // Start fade-out animation
    setIsFadingOut(true);
    
    // Wait for fade animation to complete before calling onComplete
    setTimeout(() => {
      onComplete();
    }, 300);
  };

  useEffect(() => {
    // Display splash for 2 seconds, then fade out
    const displayTimer = setTimeout(() => {
      handleComplete();
    }, 2000);

    return () => {
      clearTimeout(displayTimer);
    };
  }, []);

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-300 ${
        isFadingOut ? 'opacity-0' : 'opacity-100'
      }`}
      style={{ backgroundColor: '#080c14' }}
    >
      <img
        src="/images/splash-logo.png"
        alt="GoDyspo"
        className="w-48 h-48 object-contain"
      />
    </div>
  );
};

export default AnimatedSplash;
